import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
import KanbanPage from './KanbanPage.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.KANBAN,
  permissions: ['administrator', 'agent'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/kanban'),
      name: 'kanban_index',
      meta,
      component: KanbanPage,
    },
  ],
};
